import React from "react";
import { terms } from "./TermsDoc";

const Privacy = () => {
    return <div className="terms-content" style={{margin: "10%"}} dangerouslySetInnerHTML={{ __html: terms }} />;
};

export default Privacy;
